<template>
    <div>
        <el-table :data="list"  style="width: 100%">
            <el-table-column prop="id" label="订单ID" width="80px">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleView(scope.row)">
                        {{ scope.row.id }}
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column prop="type_memo" label="订单类型">
            </el-table-column>
            <el-table-column label="审核状态">
                <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.finance_audit==1 && scope.row.contract_audit == 1 " effect="dark"
                                placement="right-start">
                        <span slot="content"><span v-html="showContent(scope.row)"></span></span>
                        <span style="color: #67C23A">审核通过</span>
                    </el-tooltip>
                    <el-tooltip v-else-if="scope.row.finance_audit==0 && scope.row.contract_audit ==0 "
                                effect="dark" :content="showContent(scope.row)" placement="right-start">
                        <span slot="content"><span v-html="showContent(scope.row)"></span></span>
                        <span style="color: #F56C6C">不通过</span>
                    </el-tooltip>
                    <el-tooltip v-else effect="dark" placement="right-start">
                        <span slot="content"><span v-html="showContent(scope.row)"></span></span>
                        <span style="color: #E6A23C">待审核</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="product_memo" label="成交产品">
            </el-table-column>
            <el-table-column  label="合同金额">
                <template slot-scope="scope">
                        <span v-if="scope.row.finance">
                            {{scope.row.finance['total_amount']}}
                        </span>
                    <span v-else>
                            0
                        </span>
                </template>
            </el-table-column>
            <el-table-column label="业绩金额">
                <template slot-scope="scope">
                    <slot v-if="scope.row.finance">
                        <div>{{scope.row.finance['total_performance_amount']}}</div>
                    </slot>
                    <span v-else>
                            0
                        </span>
                </template>
            </el-table-column>
            <el-table-column label="回款金额">
                <template slot-scope="scope">
                    <div v-if="scope.row.order_sensitive_masked">******</div>
                    <div v-else-if="scope.row.finance && scope.row.finance.plan_pay">{{
                        _.reduce(scope.row.finance.plan_pay, (memo, item) => {
                        return memo + (Number(item.actual_amount) || 0)
                        }, 0)
                        }}
                    </div>
                    <div v-else>0</div>
                </template>
            </el-table-column>
            <el-table-column label="录单时间">
                <template slot-scope="scope">
                        <span v-if="scope.row.created_at">
                            {{scope.row.created_at}}
                        </span>
                    <span v-else>
                            0
                        </span>
                </template>
            </el-table-column>
            <el-table-column label="合同有效期">
                <template slot-scope="scope">
                        <span v-if="scope.row.finance">
                            <el-tooltip class="item" effect="dark" placement="bottom">
                                <div slot="content" class="line-gap">{{scope.row.finance['contract_time'][0]}}~
                            {{scope.row.finance['contract_time'][1]}}
                                </div>
                                <el-tag>{{scope.row.finance['contract_time'][1]}}...</el-tag>
                            </el-tooltip>
                        </span>
                    <span v-else>
                            无
                        </span>
                </template>
            </el-table-column>
            <el-table-column label="订单负责人">
                <template slot-scope="scope">
                    <div v-for="saleman in scope.row.user" :key="saleman.id">
                        <span v-if="!saleman.is_cooperator">{{saleman.name}}</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="linkPage">
            <pagination :linkPage="linkPage"></pagination>
        </el-row>
    </div>
</template>
<style>
    .scrollbar .el-table__body-wrapper::-webkit-scrollbar {
        width: 1px; /*一定要给高度，不然下面的样式无效，很蛋疼*/
    }

    .scrollbar .el-table__body-wrapper::-webkit-scrollbar-thumb {
        background: #99a9bf;
        border-radius: 5px;
    }
</style>
<script>
    import Pagination from "~/widgets/Pagination.vue";
    import OrderService from "~/services/order";
    export default {
        name: "order_table",
        props:{
            customer_id:{
                required: true
            },
        },
        components:{
            Pagination
        },
        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            let params = {customer_id:this.customer_id,type:4};
            params['page'] = to.query["page"];
            params['perPage'] = to.query["perPage"];
            this.getCustomerOrder(params);
        },
        watch: {
            $route(to, from) {
                let params = {customer_id:this.customer_id,type:4};
                 params['page'] = to.query["page"];
                 params['perPage'] = to.query["perPage"];
                this.getCustomerOrder(params);
            }
        },
        data(){
            return {
                list: [],
                linkPage: null,
            }
        },

        created(){
            this.getCustomerOrder({customer_id:this.customer_id,type:4});
        },
        methods:{
            getCustomerOrder(params = {}) {
                OrderService.commonList(params).then(res => {
                    this.loading = false;
                    if (this.currentUseTab != params.tab) return false;
                    this.list = res.data;
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                });
            },
            showContent(row) {
                return OrderService.showCheckInfo(row);
            },
            handleView(order) {
                let routeData = this.$router.resolve({
                    path: "/order/view",
                    query: {id: order.id},
                });
                window.open(routeData.href, '_blank');
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/partial/order_table.vue